'use strict';

define('vb/private/stateManagement/appPackageTranslationsMixin',[
  'vb/helpers/mixin',
  'vb/private/stateManagement/translationsMixin',
  'vb/private/constants',
], (
  Mixin,
  TranslationsMixin,
  Constants,
) => {
  /**
   * Mixin that should be used by all app package containers.
   *
   * It provides configuration for the i18n translation bundles for package resources (PackageFlow, PackagePage).
   */
  const AppPackageTranslationsMixin = (superclass) => class extends Mixin(superclass).with(TranslationsMixin) {
    /**
     * V2 translations bundle resource name represented by '$default' bundle.
     *
     * @type {string}
     */
    // eslint-disable-next-line class-methods-use-this
    get defaultBundleResourceName() {
      return Constants.DefaultBundleResourceNames.APPUI;
    }

    /**
     * Location of local V2 translations bundles.
     * For convenience, omit the 'resources/translations/' suffix to the path location.
     *
     * @type {string}
     */
    get translationsLocation() {
      return this.package && this.package.resourceLoc;
    }
  };

  return AppPackageTranslationsMixin;
});

